import createElement from "./create-element.js";

class Filter {
  constructor(element, initialValues) {
    this.element = element;
    this.visibility = "hidden";
    this.addControls();
    this.setInitialValues(initialValues);
    this.addEventListeners();

    this.observers = {
      input: [],
      submit: []
    };
  }

  addControls() {
    let controls = {};

    const controlGroupNameToSelectorMap = [
      ["dateCommenced", ".date-commenced"],
      ["purchaseCost", ".purchase-cost"],
      ["shareCost", ".share-cost"],
      ["salePrice", ".sale-price"]
    ];

    for (const [controlGroupName, selector] of controlGroupNameToSelectorMap) {
      const controlGroup = this.select(selector);
      controls[controlGroupName] = controlGroup.querySelectorAll("input");
    }

    const sharesStatusControlGroup = this.select(".share-status");
    controls.sharesStatus = sharesStatusControlGroup.querySelector("select");
    controls.resultCount = this.select(".filter-results-number");
    this.controls = controls;
  }

  addEventListeners() {
    this.addFilterListeners();

    this.element.addEventListener("submit", (event) => {
      event.preventDefault();
      this.notifyObservers("submit");
      this.hide();
    });

    this.element.addEventListener("reset", (event) => {
      event.preventDefault();
      this.reset();
    });
  }

  setInitialValues(initialValues) {
    const { projectCount, ...values } = initialValues;
    const { sharesStatus, resultCount, ...controls } = this.controls;

    for (const [name, inputs] of Object.entries(controls)) {
      for (const input of inputs) {
        const inputPosition = input === inputs[0] ? 0 : 1;
        const value = values[name][inputPosition];
        input.value = value;
        input.dataset.initialValue = value;
      }
    }

    sharesStatus.value = values.sharesStatus;
    sharesStatus.dataset.initialValue = values.sharesStatus;
    this.select(".filter-results-number").textContent = projectCount;
    this.values = values;
  }

  addFilterListeners() {
    const { sharesStatus, resultCount, ...controls } = this.controls;

    for (const [name, inputs] of Object.entries(controls)) {
      for (const input of inputs) {
        input.addEventListener("input", (event) => {
          if (inputs[0].value >= inputs[1].value) return;
          const input = event.target;
          let value = input.value;
          if (value === "") return;
          if (input.type === "number") value = parseFloat(value);
          const inputPosition = input === inputs[0] ? 0 : 1;
          this.values[name][inputPosition] = value;
          this.notifyObservers("input");
        });
      }
    }

    sharesStatus.addEventListener("change", (event) => {
      this.values.sharesStatus = event.target.value;
      this.notifyObservers("input");
    });
  }

  reset() {
    const { sharesStatus, resultCount, ...controls } = this.controls;

    for (const [name, inputs] of Object.entries(controls)) {
      for (const input of inputs) {
        setTimeout(() => {
          const initialValue = input.dataset.initialValue;
          input.value = initialValue;
          const inputPosition = input === inputs[0] ? 0 : 1;
          this.values[name][inputPosition] = initialValue;
        }, 50);
      }
    }

    setTimeout(() => {
      const initialValue = sharesStatus.dataset.initialValue;
      sharesStatus.value = initialValue;
      this.values.sharesStatus = initialValue;
      this.notifyObservers("input");
    }, 50);
  }

  updateValue({ input, valueObject, value, property }) {
    input.value = value;
    valueObject[property] = value;
  }

  select(selector) {
    return this.element.querySelector(selector);
  }

  show() {
    if (this.visibility === "visible") return;
    this.visibility = "visible";
    this.element.classList.add("show");
  }

  hide() {
    if (this.visibility === "hidden") return;
    this.visibility = "hidden";
    this.element.classList.remove("show");
  }

  toggle() {
    if (this.visibility === "visible") this.hide();
    else this.show();
  }

  addObserver(event, observer) {
    this.observers[event].push(observer);
  }

  notifyObservers(event) {
    for (const observer of this.observers[event]) {
      observer(this.values);
    }
  }

  updateResultCount(resultCount) {
    this.controls.resultCount.textContent = resultCount;
  }
}

export default Filter;
